import { useTranslation } from "../../i18n/useTranslation";
import { FixcenterSupportType } from "./fixcenter-support-type.enum";
import styles from "./FixcenterSupport.module.scss";
import FixcenterSupportSeeDetail from "./FixcenterSupportSeeDetail";
import parse from 'html-react-parser';
import { Tooltip } from '@mui/material';
import ourSalesImage from '../../assets/img/fixcenter_our_sales.jpg';
import ourSupportImage from '../../assets/img/fixcenter_our_support.jpg';
import calculationProgram from '../../assets/img/fixcenter_calculation_program.png';
import { redirectToCalaculationProgramDemo } from "../../services/calculation-program.service";
import { User } from "../client-panel/components/my-account-info/models/user.model";
import { useBetween } from "use-between";
import { UserDetailsUseBetween } from "../../shared/use-between/user-details-use-between";

export interface FixcenterSupportProps {
    variant: number; // variant 1 -> mainpage version / variant 2 -> productsthirdlevel version
}

const FixcenterSupport: React.FC<FixcenterSupportProps> = ({ variant }) => {
    const { t } = useTranslation('translation');
    const { userDetails } = useBetween(UserDetailsUseBetween);

    return (
        <>
            <div className={styles.container}>
                {variant === 1 && (
                    <div className={styles.part}>
                        <Tooltip
                            placement="top"
                            PopperProps={{
                                popperOptions: {
                                    modifiers: [{
                                        name: "offset",
                                        options: {
                                            offset: [0, -200],
                                        }}
                                    ]
                                }
                            }}
                            title={<span className={styles.tooltip_text}>{t('SUPPORT_DETAILS.DEF_1')}</span>}>
                            <div>
                                <img src={calculationProgram} alt="Our Sales" />
                                <div className={styles.text}>
                                    <div className={styles.first_column}>
                                        <span className={styles.header_details}>{parse(t('CALCULATION_PROGRAM'))}</span>
                                         <FixcenterSupportSeeDetail type={FixcenterSupportType.CALCULATION_PROGRAM}/>
                                    </div>
                                    <div className={styles.second_column}>
                                        <button onClick={() => { redirectToCalaculationProgramDemo(userDetails as User) }}>
                                            {t('TRY_IT')}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </Tooltip>
                    </div>
                )}
                <div 
                    className={styles.part}
                    style={{width: variant === 2 ? '49%' : '33%'}}>
                    <Tooltip
                        placement="top"
                        PopperProps={{
                            popperOptions: {
                                modifiers: [{
                                    name: "offset",
                                    options: {
                                        offset: [0, -200],
                                    }}
                                ]
                            }
                        }}
                        title={<span className={styles.tooltip_text}>{t('SUPPORT_DETAILS.DEF_2')}</span>}>
                        <div>
                            <img src={ourSalesImage} alt="Our Support" />
                            <div className={styles.text}>
                                <div className={styles.first_column}>
                                    <span className={styles.header_details}>{parse(t('OUR_SALES'))}</span>
                                    <FixcenterSupportSeeDetail type={FixcenterSupportType.OUR_SALES}/>
                                </div>
                            </div>
                        </div>
                    </Tooltip>
                </div>
                <div 
                    className={styles.part}
                    style={{width: variant === 2 ? '49%' : '33%'}}>
                    <Tooltip
                        placement="top"
                        PopperProps={{
                            popperOptions: {
                                modifiers: [{
                                    name: "offset",
                                    options: {
                                        offset: [0, -200],
                                    }}
                                ]
                            }
                        }}
                        title={<span className={styles.tooltip_text}>{t('SUPPORT_DETAILS.DEF_3')}</span>}>
                        <div>
                            <img src={ourSupportImage} alt="Our Support" />
                            <div className={styles.text}>
                                <div className={styles.first_column}>
                                    <span className={styles.header_details}>{parse(t('OUR_SUPPORT'))}</span>
                                    <FixcenterSupportSeeDetail type={FixcenterSupportType.OUR_SUPPORT}/>
                                </div>
                            </div>
                        </div>
                    </Tooltip>
                </div>
            </div >
        </>
    );
};

export default FixcenterSupport;
